import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import WorkflowEditorComponent from '../dashboard/WorkflowEditorComponent';

function WorkflowEditorView() {
  return (
    <MainLayout>
      <WorkflowEditorComponent />
    </MainLayout>
  );
}

export default WorkflowEditorView;
